// Phase 1A Step 36 — Eyebrow atom.
//
// Section/card kicker. Wraps the existing `.sz-eyebrow` class in
// `src/styles/globals.css` and exposes the prototype's `muted` /
// `noLine` modifiers as boolean props.
//
// Source: handoff_phantom_mode/prototype/lib.jsx → <Eyebrow>.
// Production class name `.sz-eyebrow` (already shipped in Step 21+
// `globals.css`) wins over the prototype's `.eyebrow`. The two
// modifier classes (`.muted`, `.no-line`) were added to globals.css
// in Step 36 alongside this atom.
//
// No localStorage, no fetch, no random. Pure presentational.

import type { CSSProperties, ReactNode } from "react";

interface EyebrowProps {
  children: ReactNode;
  /** Switches text + tick color from amber to text-muted. */
  muted?: boolean;
  /** Drops the 24px gold tick before the text. */
  noLine?: boolean;
  /** Optional inline style overrides — used sparingly. */
  style?: CSSProperties;
  /** Additional className to merge with the eyebrow class set. */
  className?: string;
}

export function Eyebrow({
  children,
  muted = false,
  noLine = false,
  style,
  className,
}: EyebrowProps): JSX.Element {
  const classes = ["sz-eyebrow"];
  if (muted) classes.push("muted");
  if (noLine) classes.push("no-line");
  if (className) classes.push(className);
  return (
    <span className={classes.join(" ")} style={style}>
      {children}
    </span>
  );
}
